import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Order {

    /**
    * 订单列表
    */
    export var getOrderList = (query: any): Promise<any> => {
        return Get(`/csp/Order/getOrderList?${qs.stringify(query)}`, {});
    };

    /**
  * 订单详情 (复制新增时调用)
  */
    export var getOrderDetail = (id): Promise<any> => {
        return Get(`/csp/Order/getOrderDetail/${id}`, {});
    };

    /**
* 订单详情
*/
    export var getOrder = (id): Promise<any> => {
        return Get(`/csp/Order/getOrder/${id}`, {});
    };

    /**
* 获取定位页面结果
*/
    export var GetLocationPageResult = (query: any): Promise<any> => {
        return Get(`/csp/Order/GetLocationPageResult?${qs.stringify(query)}`, {});
    };


    /**
* 终结
*/
    export var EndOrder = (query: any): Promise<any> => {
        return Put(`/csp/Order/EndOrder?${qs.stringify(query)}`, query);
    };

    /**
* 跟踪
*/
    export var getOrderProcessList = (query: any): Promise<any> => {
        return Get(`/csp/Order/getOrderProcessList?${qs.stringify(query)}`, {});
    };

    /**
  * 导出
  */
    export var GetOrderListExport = (query: any): Promise<any> => {
        return Get(`/csp/Order/GetOrderListExport?${qs.stringify(query)}`, {});
    };




}

